// src/validators/index.js
import { extend } from "vee-validate";
import * as Yup from "yup";

// Các rule phổ biến nhất – dùng lại ở mọi form
extend("required", {
  validate: (value) => !!value || "Trường này là bắt buộc",
});
extend("email", {
  validate: (value) => /.+@.+\..+/.test(value) || "Email không hợp lệ",
});

// Rule phức tạp: object có id (menu, category, user...)
extend("hasId", {
  validate: (value) => !!value?.id || "Vui lòng chọn {_field_}",
  params: ["_field_"],
});

extend("hasFileId", {
  validate(value) {
    return !!value?.fileId || "Vui lòng tải ảnh đại diện lên";
  },
});

//Chỉ được nhập ký tự chữ
extend("alphaSpaces", {
  validate: (value) =>
    /^[A-Za-zÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/.test(
      value
    ) || "{_field_} chỉ được chứa ký tự chữ",
    params: ["_field_"],
});

// Rule CKEditor không rỗng
extend("ckeditor", {
  validate: (value) => {
    if (!value) return "Nội dung không được để trống";
    const text = value.replace(/<[^>]*>/g, "").trim();
    return text.length > 0 || "Nội dung không được để trống";
  },
});

export default {};
